// extracted by mini-css-extract-plugin
module.exports = {"element":"filter-input_element__10Pqj","empty":"filter-input_empty__d0jga"};